import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ErrorWrapper, getErrorText } from '@trade-platform/ui-shared';
import {
    OrderSendBundle,
    OrderSendBundleActionTypes,
    OrderSendBundleFailure,
    OrderSendBundleSuccess
} from './actions';
import { OrderSendBundleService } from './service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class OrderSendBundleEffects {
    private actions$ = inject(Actions);
    private orderSendBundleService = inject(OrderSendBundleService);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderSendBundle$ = createEffect(() =>
        this.actions$.pipe(
            ofType<OrderSendBundle>(OrderSendBundleActionTypes.ORDER_SEND_BUNDLE),
            switchMap(action =>
                this.orderSendBundleService
                    .sendBundle({
                        orderIds: action.payload.orderIds,
                        emailSubject: action.payload.emailSubject,
                        emailBody: action.payload.emailBody
                    })
                    .pipe(
                        map(res => new OrderSendBundleSuccess(res)),
                        catchError((error: string | HttpErrorResponse) => {
                            let err;
                            if (error instanceof HttpErrorResponse) {
                                // The backend send-bundle fails closed (all-or-nothing): a 422 means the
                                // selection was unauthorized/ineligible/stale and NOTHING was sent. Surface
                                // its message so Step 4 can show "nothing was sent — re-check the selection"
                                // and re-fetch candidates (aix-ui#5491).
                                if (error.status === 422) {
                                    err = new ErrorWrapper(error.message, {
                                        status: error.status,
                                        errorText: error.error?.message
                                    });
                                } else {
                                    err = new ErrorWrapper(error.message, {
                                        status: error.status,
                                        errorText: getErrorText(error)
                                    });
                                }
                            } else {
                                err = new ErrorWrapper(error);
                            }
                            return of(new OrderSendBundleFailure({ error: err as ErrorWrapper }));
                        })
                    )
            )
        )
    );
}
